import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
    selector: 'stm-skeleton',
    template: '<span class="stm-skeleton" aria-hidden="true" [class.stm-skeleton--circle]="circle()" [style.width]="width()" [style.height]="height()" [style.border-radius]="circle() ? null : radius()"></span>',
    styleUrl: './skeleton.css',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class StmSkeleton {
    readonly width = input('100%');
    readonly height = input('1rem');
    readonly radius = input('6px');
    readonly circle = input(false);
}
